export enum RescheduleType {
  LockRescheduleUser = 1,
  Reassign = 2,
}
